import { render, staticRenderFns } from "./WhatsAppBubble.vue?vue&type=template&id=1e1f9328&scoped=true&"
import script from "./WhatsAppBubble.vue?vue&type=script&lang=js&"
export * from "./WhatsAppBubble.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppBubble.vue?vue&type=style&index=0&id=1e1f9328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1f9328",
  null
  
)

export default component.exports